// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/JourneyPlan/JourneyPlanDetail/Briefing/Briefing.css
// module id = 2406
// module chunks = 0